import React from 'react'
import {Row, Col} from 'reactstrap'
import PropTypes from 'prop-types'

const ClientSummary = (props) => {
    return (

        <Row {...props}>

            <Col>
                <Row className="mb-5">
                    <Col className="d-flex align-items-center flex-row">
                        <h1 className="m-0 mr-4">{props.client.name}</h1>
                    </Col>
                </Row>
                <Row>

                    <Col className="d-flex align-items-center flex-column">
                        <h1>{props.client.projects.length}</h1>
                        <p className="lead">
                            Client Projects
                        </p>
                    </Col>
                    <Col className="d-flex align-items-center flex-column">
                        <h1>{Math.floor(props.client.minutes_worked_on_all_projects && (props.client.minutes_worked_on_all_projects / 60))}</h1>
                        <p className="lead">
                            Hours worked by staff
                        </p>
                    </Col>

                </Row>
            </Col>
        </Row>
    )
}

ClientSummary.propTypes = {
    client: PropTypes.object.isRequired
}

export default ClientSummary